import { render, staticRenderFns } from "./vehicle_type.vue?vue&type=template&id=5141da20&scoped=true"
import script from "./vehicle_type.vue?vue&type=script&lang=js"
export * from "./vehicle_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141da20",
  null
  
)

export default component.exports